export default "__VITE_ASSET__C25V8srP__"